import React from "react"

interface Container<T> {
  collection: T[]
  filter: (elem: T) => boolean
  order: (a: T, b: T) => number
  heading: JSX.Element
  className?: string
  item: (item: T) => JSX.Element
}

const Container: React.FC<Container<T>> = ({
  collection,
  filter,
  order,
  heading,
  className = "",
  item,
}) => (
  <div class={className}>
    <div class="">
      {heading}
      <ul>
        {collection
          .filter(filter)
          .sort(order)
          .map(item)}
      </ul>
    </div>
  </div>
)

export default Container
